<div class="py-3">
  <custom-label [placeholder]="placeholder"></custom-label>
      <span class="p-input-icon-left w-full" >
          <input
              [type]="type"
              border-round pInputText
              [placeholder]="placeholder"
              [formControl]="value"
              (blur)="onTouch()"
              [autocomplete]="autocomplete"
              class="border w-full"
              />
              <span *ngIf="eye" class="absolute right-0 top-0 h-full flex items-center pr-3 cursor-pointer" (click)="changeType.emit()">
                <i [class]="type === 'password' ? 'pi pi-eye eye ' : 'pi pi-eye-slash eye'"></i>
              </span>
      </span>
      <span *ngIf="form && isValidField()" class="block mt-3 ml-5 text-red-500 font-italic display-6">{{errorField()}}</span>

<div >
